import { cx } from '@linaria/core';
import { useComponentEntry } from '@utils/component-framework';
import { richtextStyles } from '../organism.content/shared.richtext.style.js';
import { wrapper, heading, answer } from './atom.input.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useHTMLContent } from '../ast/util.print-html.js';

function WordPrintInput(props) {
  const heading$1 = useHTMLContent(props.input.text);
  const value = useComponentEntry(props.entryKey, {
    select: entry => entry?.data.answers[props.taskId]?.[props.input.id] ?? ""
  });
  const answer$1 = useHTMLContent(value.data || props.input.predefinedAnswer || "");
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    children: [!!heading$1?.length && /*#__PURE__*/jsx("div", {
      "data-print-content": true,
      className: cx(heading, richtextStyles),
      children: heading$1
    }), /*#__PURE__*/jsx("span", {
      "data-print-content": true,
      className: cx(answer, richtextStyles),
      children: answer$1?.length ? answer$1 : " "
    })]
  });
}

export { WordPrintInput };
//# sourceMappingURL=atom.input.js.map
